module.exports = __webpack_public_path__ + "static/media/grand_1.b6a96ce4.jpeg";